<template>
  <div>
    <!-- <mheader></mheader> -->
    <div
      v-show="tableData.length > 0 || searchData.length > 0"
      style="width: 1300px; margin: 0 auto"
      id="v-content"
      :style="{ minHeight: Height + 'px' }"
    >
      <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888">
        <p class="mt-2 font">
          <img
            src="../../static/images/duizhang.png"
            style="width: 1.5rem; height: 1.5rem"
            class="mb-lg-1"
            alt=""
          />
          <span
            class="p-1"
            style="
              text-shadow: #000 1px 0 0;
              background-color: #3190e8;
              color: #fff;
              box-shadow: 6px 4px 9px #888888;
              font-family: Helvetica Neue, Tahoma, Arial;
              border-radius: 3px;
            "
          >
            销售对账
          </span>
          <span>
            <!-- <span>
              <span class="ml-5"> 显示 </span>
              <span class="record">{{ PageNo }}</span
              >-<span class="record">{{ Pcount }}</span
              >页,
            </span>
            <span>
              总共<span class="record">{{ Record }}</span
              >条数据
            </span> -->
          </span>
          <span
            class="float-right span_close"
            style="
              display: block;
              width: 20px;
              line-height: 20px;
              text-align: center;
              font-size: 25px;
            "
            @click="$router.go(-1)"
          >
            &times;
          </span>
        </p>
        <p class="mb-2 mt-2" style="align: right; font-size: 14px">
          <span style="margin-left: 6rem">
            <span class="ml-3"> 查询数量总计: </span>
            <span class="totalNum">{{ totalNum }}</span>
          </span>
          <span>
            <span class="ml-3"> (真实)销售金额总计: </span>
            <span class="money">¥{{ totalMoney }}</span>
          </span>
          <span>
            <span class="ml-3"> (真实)费用合计: </span>
            <span class="money">¥{{ feeMoney }}</span>
          </span>

          <span>
            <span class="ml-3"> 毛利合计: </span>
            <span class="money">¥{{ totalProfits }}</span>
          </span>
          <span>
            <span class="ml-3"> 亏损额合计: </span>
            <span class="money">¥{{ totalGrossDeficit }}</span>
          </span>
          <span>
            <span class="ml-3"> 增值额合计: </span>
            <span class="money">¥{{ totalGrossProfit }}</span>
          </span>
          <span>
            <span class="ml-3"> 查询时间: </span>
            <span class="money">{{ searchForm.DateSpan }}</span>
          </span>
        </p>
        <p class="mb-2 mt-2">
          <span style="font-weight: 600; color: red"
            >销售对账(双击药品名称或者生产厂家可以快速检索！)</span
          >
        </p>
        <div class="row ml-lg-2 m-0 mb-2">
          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-4">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">药品名称:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.ypmc"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-4">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">生产厂家:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.cdmc"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">规格:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.gg"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="row">
              <div class="col-lg-6">
                <div class="row">
                  <div class="col-lg-6 p-0 text-center font">选择年月:</div>
                  <div class="col-lg-6 p-0">
                    <div>
                      <select
                        name=""
                        id=""
                        v-model="searchForm.DateSpan"
                        class="hei font"
                      >
                        <option
                          v-for="(item, index) in selectTime"
                          :key="index"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="row">
                  <div class="col-lg-6 p-0 text-center font">销售渠道:</div>
                  <div class="col-lg-6 p-0">
                    <div>
                      <select
                        name=""
                        id=""
                        v-model="searchForm.SaleWay"
                        class="hei font"
                      >
                        <option
                          v-for="(item, index) in selectList"
                          :key="index"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 p-0">
            <div class="row ml-lg-5 p-0">
              <button
                class="bg-primary button_zi hei"
                style="width: 20%"
                @click="getSearch()"
              >
                查询
              </button>
              <button
                class="bg-success button_zi ml-lg-2"
                style="width: 20%"
                @click="start_print()"
              >
                打印
              </button>
              <button
                class="bg-success button_zi ml-lg-2"
                style="width: 40%"
                @click="exportExcel()"
              >
                导出查询EXCEL
              </button>
            </div>
          </div>
        </div>
        <table
          v-if="searchData.length > 0"
          class="table table-striped table-hover"
          ref="print"
        >
          <thead>
            <tr style="white-space: nowrap">
              <th>日期</th>
              <th>药品名称</th>
              <th>产地名称</th>
              <th>销售渠道</th>
              <th>规格</th>
              <th>包装</th>
              <th>单位</th>
              <th>数量</th>
              <th>金额</th>
              <th>成本</th>
              <th>进价</th>
              <th>毛利</th>
              <th>亏损额</th>
              <th>增值额</th>
              <th>绩效</th>
              <th>增值税</th>
              <th>费用合计</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in searchData" :key="index">
              <td>{{ item.dateSpan }}</td>
              <td @dblclick="onInputdrugName(index)">{{ item.drugName }}</td>
              <td @dblclick="onInputcustomerName(index)">
                {{ item.productFactory }}
              </td>
              <td>{{ item.SaleWay }}</td>
              <td>{{ item.spec }}</td>
              <td>{{ item.pack }}</td>
              <td>{{ item.unit }}</td>
              <td>{{ item.storeNum }}</td>
              <td>{{ item.amountMoney }}</td>
              <td>{{ item.cost }}</td>
              <td>{{ item.purchasePrice }}</td>
              <td>{{ item.totalProfit }}</td>
              <td>{{ item.grossDeficit }}</td>
              <td>{{ item.grossProfit }}</td>
              <td>{{ item.achievements }}</td>
              <td>{{ item.invoiceMoney }}</td>
              <td>{{ item.totalFee }}</td>
            </tr>
          </tbody>
        </table>
        <table class="table table-striped table-hover" ref="print" v-else>
          <thead>
            <tr style="white-space: nowrap">
              <th>日期</th>
              <th>药品名称</th>
              <th>产地名称</th>
              <th>销售渠道</th>
              <th>规格</th>
              <th>包装</th>
              <th>单位</th>
              <th>数量</th>
              <th>金额</th>
              <th>成本</th>
              <th>进价</th>
              <th>毛利</th>
              <th>亏损额</th>
              <th>增值额</th>
              <th>绩效</th>
              <th>增值税</th>
              <th>费用合计</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in tableData" :key="index">
              <td>{{ item.dateSpan }}</td>
              <td @dblclick="onInputdrugName(index)">{{ item.drugName }}</td>
              <td @dblclick="onInputcustomerName(index)">
                {{ item.productFactory }}
              </td>
              <td>{{ item.SaleWay }}</td>
              <td>{{ item.spec }}</td>
              <td>{{ item.pack }}</td>
              <td>{{ item.unit }}</td>
              <td>{{ item.storeNum }}</td>
              <td>{{ item.amountMoney }}</td>
              <td>{{ item.cost }}</td>
              <td>{{ item.purchasePrice }}</td>
              <td>{{ item.totalProfit }}</td>
              <td>{{ item.grossDeficit }}</td>
              <td>{{ item.grossProfit }}</td>
              <td>{{ item.achievements }}</td>
              <td>{{ item.invoiceMoney }}</td>
              <td>{{ item.totalFee }}</td>
            </tr>
          </tbody>
        </table>
        <el-pagination
          style="text-align: center; margin-bottom: 15px"
          @current-change="CurrentChange"
          :current-page="pageIndex"
          :page-size="20"
          background
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
        <!-- 分页 -->
        <!-- <div class="row m-0">
          <nav
            aria-label="Page navigation"
            style="text-align: center"
            class="mb-1"
          >
            <ul class="pagination">
              <li
                class="page-item ml-5"
                :class="PageNo <= 1 ? 'disabled' : ''"
                @click="prePage()"
              >
                <a aria-label="Previous" class="page-link">
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
              <li
                :class="index == PageNo ? 'active' : ''"
                class="page-item"
                v-for="index of Pcount"
                :key="index"
                @click="curPage(index)"
              >
                <a class="page-link" v-if="index <= 20">{{ index }}</a>
                <a class="page-link" v-if="index > 20 && index == Pcount - 1"
                  >...</a
                >
                <a class="page-link" v-if="index > 20 && index == Pcount">{{
                  Pcount
                }}</a>
              </li>

              <li
                class="page-item"
                :class="PageNo >= Pcount ? 'disabled' : ''"
                @click="nextPage()"
              >
                <a aria-label="Next" class="page-link">
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
          </nav>
        </div> -->
        <p class="text-center">
          <img
            src="../../static/images/tuding.png"
            style="width: 1.5rem; height: 1.5rem"
            alt=""
          />
        </p>
        <!-- <div class="row p-0 m-0">        
          <p>
            <span>
                          查询数量总计：<span class="money">¥{{totalNum}}</span>
            </span>
            <span>
                          (真实)销售金额总计: <span class="money">¥{{totalMoney}}</span>
            </span>
            <span>
                        (真实)费用合计: <span class="money">¥{{feeMoney}}</span>
            </span>
            <span>
                        查询时间: <span class="money">{{searchForm.DateSpan}}</span>
            </span>
            <span>
                  显示<span class="record">{{PageNo}}</span>-<span class="record">{{Pcount}}</span>条,
            </span>
            <span>
                  总共<span class="record">{{Record}}</span>条数据
            </span>
          </p>                                                                                                   
        </div> -->
      </div>
    </div>
    <div
      v-show="Pcount === 0"
      style="width: 1300px; margin: 0 auto"
      id="v-content"
      :style="{ minHeight: Height + 'px' }"
    >
      <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888">
        <p class="mt-2 font">
          <img
            src="../../static/images/duizhang.png"
            style="width: 1.5rem; height: 1.5rem"
            class="mb-lg-1"
            alt=""
          />
          <span
            class="p-1"
            style="
              text-shadow: #000 1px 0 0;
              background-color: #3190e8;
              color: #fff;
              box-shadow: 6px 4px 9px #888888;
              font-family: Helvetica Neue, Tahoma, Arial;
              border-radius: 3px;
            "
          >
            销售对账
          </span>
          <span>
            <span class="ml-5">
              <span class="ml-3"> 查询数量总计: </span>
              <span class="totalNum">{{ totalNum }}</span>
            </span>
            <span>
              <span class="ml-3"> (真实)销售金额总计: </span>
              <span class="money">¥{{ totalMoney }}</span>
            </span>
            <span>
              <span class="ml-3"> (真实)费用合计: </span>
              <span class="money">¥{{ feeMoney }}</span>
            </span>
            <span>
              <span class="ml-3"> 查询时间: </span>
              <span class="money">{{ searchForm.DateSpan }}</span>
            </span>

            <span>
              <span class="ml-5"> 显示 </span>
              <span class="record">{{ PageNo }}</span
              >-<span class="record">{{ Pcount }}</span
              >页,
            </span>
            <span>
              总共<span class="record">{{ Record }}</span
              >条数据
            </span>
          </span>
          <span
            class="float-right span_close"
            style="
              display: block;
              width: 20px;
              line-height: 20px;
              text-align: center;
              font-size: 25px;
            "
            @click="$router.go(-1)"
          >
            &times;
          </span>
        </p>
        <p class="mb-2 mt-2">
          <span style="font-weight: 600; color: red"
            >销售对账(双击药品名称或者生产厂家可以快速检索！)</span
          >
        </p>
        <div class="row ml-lg-2 m-0 mb-2">
          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-4">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">药品名称:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.ypmc"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-4">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">生产厂家:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.cdmc"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="row">
                      <div class="col-lg-6 p-0 text-center font">规格:</div>
                      <div class="col-lg-6 p-0">
                        <input
                          type="text"
                          class="form-control font"
                          v-model="searchForm.gg"
                          style="height: 1.5rem"
                          @keydown.enter="searchEnterFun"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="row">
              <div class="col-lg-6">
                <div class="row">
                  <div class="col-lg-6 p-0 text-center font">选择年月:</div>
                  <div class="col-lg-6 p-0">
                    <div>
                      <select
                        name=""
                        id=""
                        v-model="searchForm.DateSpan"
                        class="hei font"
                      >
                        <option
                          v-for="(item, index) in selectTime"
                          :key="index"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="row">
                  <div class="col-lg-6 p-0 text-center font">销售渠道:</div>
                  <div class="col-lg-6 p-0">
                    <div>
                      <select
                        name=""
                        id=""
                        v-model="searchForm.SaleWay"
                        class="hei font"
                      >
                        <option
                          v-for="(item, index) in selectList"
                          :key="index"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 p-0">
            <div class="row ml-lg-5 p-0">
              <button
                class="bg-primary button_zi hei"
                style="width: 20%"
                @click="getSearch()"
              >
                查询
              </button>
              <button
                class="bg-success button_zi ml-lg-2"
                style="width: 20%"
                @click="start_print()"
              >
                打印
              </button>
              <button
                class="bg-success button_zi ml-lg-2"
                style="width: 40%"
                @click="exportExcel()"
              >
                导出查询EXCEL
              </button>
            </div>
          </div>
        </div>

        <img
          src="../../static/images/wushuju.jpg"
          style="width: 300px; height: 300px; display: block; margin: 0 auto"
          alt=""
        />
        <p class="text-center">
          <img
            src="../../static/images/tuding.png"
            style="width: 1.5rem; height: 1.5rem"
            alt=""
          />
        </p>
      </div>
    </div>
    <div>
      <transition name="fade">
        <loading v-if="isLoading"></loading>
      </transition>
    </div>
    <!-- 表单内容 -->

    <!-- Footer -->
    <!-- <mfooter></mfooter> -->
  </div>
</template>
<script>
// import mheader from '../components/Header.vue'
// import mfooter from '../components/Footer.vue'
import Loading from "../components/Loading.vue";
import { async } from "q";

export default {
  name: "SaleQuery",
  data() {
    return {
      Height: 0,
      searchForm: {
        ypmc: "",
        cdmc: "",
        ph: "",
        gg: "",
        DateSpan: "",
        SaleWay: "", // 今天+1
      }, //搜索内容
      selectList: [
        { name: "正常销售" },
        { name: "零库销售" },
        { name: "新药部" },
        { name: "物流部" },
        { name: "全部销售" },
      ],
      selectTime: [{ name: "" }, { name: "" }, { name: "" }],
      searchData: [], //搜索返回的清单
      isLoading: false,
      tableData: [],
      Record: "", //总记录数
      Pcount: "", //总页数
      PageNo: 1, //当前页码
      totalNum: "",
      totalMoney: "",
      feeMoney: "",
      totalProfits: "",
      totalGrossDeficit: "",
      totalGrossProfit: "",
      excelData: [],
      // pageSize:20,
      total: 0,
      pageIndex: 1,
    };
  },
  components: {
    // mheader,
    // mfooter,
    Loading,
  },
  computed: {},

  methods: {
    time: function () {
      const date = new Date();
      const time_year = date.getFullYear();
      let time1_month = date.getMonth();
      let time2_month = date.getMonth() - 1;
      let time1 = "" + time_year + "0" + time1_month;
      let time2 = "" + time_year + "0" + time2_month;
      this.selectTime[1].name = time2;
    },
    getLastMonthYestdy(Month, index) {
      var date = new Date();
      var daysInMonth = new Array(
        [0],
        [31],
        [28],
        [31],
        [30],
        [31],
        [30],
        [31],
        [31],
        [30],
        [31],
        [30],
        [31]
      );
      var strYear = date.getFullYear();
      var strDay = date.getDate();
      var strMonth = date.getMonth() + 1;
      if (strYear % 4 == 0 && strYear % 100 != 0) {
        daysInMonth[2] = 29;
      }
      if (strMonth - Month == 0) {
        strYear -= 1;
        strMonth = 12;
      } else if (strMonth - Month == -1) {
        strYear -= 1;
        strMonth = 11;
      } else if (strMonth - Month == -2) {
        strYear -= 1;
        strMonth = 10;
      } else {
        strMonth -= Month;
      }
      strDay = daysInMonth[strMonth] >= strDay ? strDay : daysInMonth[strMonth];
      if (strMonth < 10) {
        strMonth = "0" + strMonth;
      }
      if (strDay < 10) {
        strDay = "0" + strDay;
      }
      var datastr = "" + strYear + strMonth;
      this.selectTime[index].name = datastr;
    },
    searchEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getSearch();
      }
    },
    //导出查询
    exportExcel() {
      const that = this;
      require.ensure([], async () => {
        const { export_json_to_excel } = require("../Excel/Export2Excel"); //注意这个Export2Excel路径
        const tHeader = [
          "日期",
          "药品名称",
          "产地名称",
          "销售渠道",
          "规格",
          "包装",
          "单位",
          "数量",
          "金额",
          "成本",
          "进价",
          "毛利",
          "亏损额",
          "增值额",
          "绩效",
          "增值税",
          "费用合计",
        ]; // 上面设置Excel的表格第一行的标题
        const filterVal = [
          "dateSpan",
          "drugName",
          "productFactory",
          "SaleWay",
          "spec",
          "pack",
          "unit",
          "storeNum",
          "amountMoney",
          "cost",
          "purchasePrice",
          "totalProfit",
          "grossDeficit",
          "grossProfit",
          "achievements",
          "invoiceMoney",
          "totalFee",
        ]; // 上面的index、nickName、name是tableData里对象的属性key值
        await that.getExcelData();
        const list = that.excelData;
        const data = that.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, "销售对账"); //最后一个是表
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    // ypmc:function(){
    //         let reg1=/^[\u4e00-\u9fa5]{0,}$/;
    //          if(!reg1.test(this.searchForm.ypmc)){
    //                $("#ypmc").removeClass("d-none")
    //          }
    //          else{
    //               $("#ypmc").addClass("d-none")
    //          }
    //     },
    //     ph:function(){
    //          let reg2=/^[0-9]*$/;
    //          if(!reg2.test(this.searchForm.ph)){
    //                $("#ph").removeClass("d-none")
    //          }
    //          else{
    //               $("#ph").addClass("d-none")
    //          }
    //     },
    //     cdmc:function(){
    //           let reg3=/^[\u4e00-\u9fa5]{0,}$/;
    //           if(!reg3.test(this.searchForm.cdmc)){
    //                $("#cdmc").removeClass("d-none")
    //          }
    //          else{
    //                $("#cdmc").addClass("d-none")
    //          }
    //     },
    //     gg:function(){
    //           let reg4=/^[\u4E00-\u9FA5A-Za-z0-9_]+$/;
    //            if(!reg4.test(this.searchForm.gg)){
    //                $("#gg").removeClass("d-none")
    //          }
    //          else{
    //               $("#gg").addClass("d-none")
    //          }
    //     },
    onInputdrugName: function (index) {
      if (this.searchData.length > 0) {
        this.searchForm.ypmc = this.searchData[index].drugName;
      } else {
        this.searchForm.ypmc = this.tableData[index].drugName;
      }
    },
    onInputcustomerName: function (index) {
      if (this.searchData.length > 0) {
        this.searchForm.cdmc = this.searchData[index].productFactory;
      } else {
        this.searchForm.cdmc = this.tableData[index].productFactory;
      }
    },
    getSearch() {
      this.pageIndex = 1;
      this.Search(this.pageIndex);
    },
    getClerkSaleCheck: async function (PageIndex) {
      let that = this;
      //  that.isLoading=true;
      that.PageNo = PageIndex || that.PageNo;
      const { data: res } = await that.$http.post("Dls/getFun", {
        action: "ClerkSaleCheck",
        obj: JSON.stringify({
          PageIndex,
          PageSize: 20,
          DateSpan: that.selectTime[0].name,
          SaleWay: that.selectList[0].name,
        }),
      });
      // console.log(res)
      if (res.isok) {
        const obj = res.data;
        for (let i = 0; i < obj.rows.length; i++) {
          that.$set(obj.rows[i], "SaleWay", that.searchForm.SaleWay);
        }
        that.tableData = obj.rows;
        that.total = obj.record;
        that.Pcount = obj.pcount;
        that.Record = obj.record;
        that.totalNum = obj.totalNum;
        that.totalMoney = obj.totalMoney;
        that.totalProfits = obj.totalProfits;
        that.totalGrossDeficit = obj.totalGrossDeficit;
        that.totalGrossProfit = obj.totalGrossProfit;
        that.feeMoney = obj.feeMoney;
      }
    },
    getExcelData: async function () {
      let that = this;
      const { data: res } = await that.$http.post("Dls/getFun", {
        action: "ClerkSaleCheck",
        obj: JSON.stringify({
          PageIndex: 1,
          PageSize: 50000,
          DrugName: that.searchForm.ypmc.trim(),
          ProductFactory: that.searchForm.cdmc.trim(),
          Spec: that.searchForm.gg.trim(),
          DateSpan: that.searchForm.DateSpan,
          SaleWay: that.searchForm.SaleWay,
        }),
      });
      //console.log(res
      if (res.isok) {
        const obj = res.data;
        for (let i = 0; i < obj.rows.length; i++) {
          that.$set(obj.rows[i], "SaleWay", that.searchForm.SaleWay);
        }
        that.excelData = obj.rows;
        // console.log(that.excelData)
      }
    },

    Search: async function (PageIndex) {
      const that = this;
      that.isLoading = true;
      if (!PageIndex) {
        PageIndex = 1;
      }
      that.PageNo = PageIndex || that.PageNo;
      const { data: res } = await this.$http.post("Dls/getFun", {
        action: "ClerkSaleCheck",
        obj: JSON.stringify({
          PageIndex,
          PageSize: 20,
          DrugName: that.searchForm.ypmc.trim(),
          ProductFactory: that.searchForm.cdmc.trim(),
          BatchNum: that.searchForm.ph.trim(),
          Spec: that.searchForm.gg.trim(),
          DateSpan: that.searchForm.DateSpan,
          SaleWay: that.searchForm.SaleWay,
        }),
      });

      // console.log(res)
      if (res.isok) {
        const obj = res.data;
        for (let i = 0; i < obj.rows.length; i++) {
          that.$set(obj.rows[i], "SaleWay", that.searchForm.SaleWay);
        }
        that.Pcount = obj.pcount;
        if (obj.pcount == 0) {
          that.tableData.length = 0;
          alert("没有符合条件的信息");
          // this.$messsage.error("没有符合条件的信息！")
        }
        that.searchData = obj.rows;
        that.total = obj.record;
        that.Record = obj.record;
        that.feeMoney = obj.feeMoney;
        that.totalNum = obj.totalNum;
        that.totalMoney = obj.totalMoney;
        that.totalProfits = obj.totalProfits;
        that.totalGrossDeficit = obj.totalGrossDeficit;
        that.totalGrossProfit = obj.totalGrossProfit;
        that.isLoading = false;
      }
    },
    // 当前页
    curPage: function (index) {
      if (this.searchData.length > 0) {
        this.getSearch(index);
      } else {
        this.getClerkSaleCheck(index);
      }
    },
    //上一页
    prePage: function () {
      if (this.PageNo > 1) {
        this.PageNo--;
        if (this.searchData.length > 0) {
          this.getSearch(this.PageNo);
        } else {
          this.getClerkSaleCheck(this.PageNo);
        }
      }
    },
    //下一页
    nextPage: function () {
      if (this.PageNo < this.Pcount) {
        this.PageNo++;
        if (this.searchData.length > 0) {
          this.getSearch(this.PageNo);
        } else {
          this.getClerkSaleCheck(this.PageNo);
        }
      }
    },
    //搜索功能
    CurrentChange(val) {
      this.pageIndex = val;
      // console.log(val)
      if (this.searchData.length > 0) {
        this.Search(val);
      } else {
        this.getClerkSaleCheck(val);
      }
      // this.getClerkSaleCheck(val)
      // this.Search(val)
    },
    // 打印
    start_print() {
      this.$print(this.$refs.print); //$refs的值要和html里的ref一致
    },
  },
  mounted() {
    //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.Height = document.documentElement.clientHeight - 100; //监听浏览器窗口变化
    window.onresize = () => {
      this.Height = document.documentElement.clientHeight - 100;
    };
  },
  created() {
    this.getLastMonthYestdy(1, 0);
    this.getLastMonthYestdy(2, 1);
    this.getLastMonthYestdy(3, 2);
    this.searchForm.DateSpan = this.selectTime[0].name;
    this.searchForm.SaleWay = this.selectList[0].name;
    this.getClerkSaleCheck();
  },
};
</script>
<style scoped>
.table-hover > tbody > tr:hover {
  background-color: #dee2e6 !important;
}
.money {
  color: red;
  font-weight: 500;
}
.totalNum {
  color: green;
  font-weight: 500;
}
.record {
  color: green;
  font-weight: 500;
}
.font {
  font-size: 15px;
}
.hei {
  height: 1.5rem;
}
.font_yz {
  font-size: 1px;
  color: red;
}
.button_zi {
  text-shadow: #000 1px 0 0;
  border-radius: 5px;
  border: none;
  color: azure;
}
.span_close:hover {
  color: #3190e8;
}
</style>


// WEBPACK FOOTER //
// src/pages/SaleCheck.vue